import { Image } from '@/components/common/Image';

export function Logo({ className, white = false }) {
  return (
    <Image
      src={white ? '/logo-white.svg' : '/logo.svg'}
      alt="Mind Mirth"
      className={className}
      draggable={false}
    />
  );
}